import styled from 'styled-components'

import { ExtendIconProps } from '@/components/ui/icons/types'

type SmallSVGProps = ExtendIconProps<{ small?: boolean }>

export const SmallSVG = styled.svg<SmallSVGProps>`
  width: ${({ small, size }) => (small ? size.width * 0.6 : size.width)}px;
  height: ${({ small, size }) => (small ? size.height * 0.6 : size.height)}px;
`
